import React from "react";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";

interface RejectButtonProps {
  langBase: string;
  permission: string | string[];
  isActionAvailable: boolean;
  onReject: () => void;
}

const RejectButton: React.FC<RejectButtonProps> = ({
  langBase,
  permission,
  isActionAvailable,
  onReject,
}) => {
  return (
    <FlowActionButton
      langBase={langBase}
      permission={permission}
      isActionAvailable={isActionAvailable}
      labelKey="reject-button"
      testId="reject"
      variant="outlined"
      startIcon={<CancelOutlinedIcon />}
      onClick={onReject}
    />
  );
};
export default RejectButton;
